/**
 * 状态文件 
 */

// 开题报告状态 
export const proposal = {
    1: { txt: "未提交", txt2: "立即提交", col: "#1963f7" }, 
    2: { txt: "已提交", txt2: "点击下载", col: "#1963f7" }, 
}; 

// 评审状态 
export const review = [ "待提交",  "已提交", "通过", "不通过" ]; 
export const review2 = [ "立即提交",  "点击下载", "通过", "不通过" ]; 

// 论文答辩状态 
// 待答辩、待提交、审核中、通过、不通过
export const replyState = {
    1: { txt: "待答辩", txt2: "立即提交", col: "#1963f7" },
    2: { txt: "待提交", txt2: "重新上传", col: "#1963f7" },
    3: { txt: "审核中", txt2: "点击下载", col: "#1963f7" }, 
    4: { txt: "通过", txt2: "-", col: "" }, 
    5: { txt: "不通过", txt2: "不通过理由", col: "#ffa500" }, 
}; 

// 培训报名 
export const train = {
    0: { txt: "未报名", txt2: "立即报名", col: "#1963f7", }, // 报名须知弹框确认后提示报名成功 
    1: { txt: "待审核", txt2: "点击查看", col: "#1963f7", },
    2: { txt: "待缴费", txt2: "上传缴费凭证", col: "#1963f7", },
    3: { txt: "驳回", txt2: "重新报名", col: "#ffa500", }, // 换行显示驳回原因 
    4: { txt: "缴费审核", txt2: "点击查看", col: "#1963f7", },
    5: { txt: "报名成功", txt2: "显示报名成功的时间", col: "", },
    6: { txt: "缴费失败", txt2: "重新上传缴费凭证", col: "#ffa500", }, // 换行显示失败原因 
}

// 论文报名状态 
export const signup = {
    // 0: { txt: "未报名", txt2: "立即报名", col: "" }, // 未报名-------立即报名（报名须知弹框，提交资料确认后提示报名成功） 
    1: { txt: "待审核", txt2: "点击查看", col: "#1963f7" },  
    2: { txt: "待缴费", txt2: "上传缴费凭证", col: "#1963f7" }, 
    3: { txt: "驳回", txt2: "重新报名", col: "#ffa500" }, 
    4: { txt: "缴费审核", txt2: "点击查看", col: "#1963f7" },  
    5: { txt: "报名成功", txt2: "显示报名成功的时间", col: "" }, 
    6: { txt: "缴费失败", txt2: "重新上传缴费凭证", col: "#ffa500" }, 
}; 

export const trainStatus = [
    { txt: "待审核", col: "", }, 
    { txt: "待缴费", col: "", }, 
    { txt: "已驳回", col: "#ffa500", }, 
    { txt: "缴费审核", col: "", }, 
    { txt: "报名成功", col: "", }, 
    { txt: "缴费失败", col: "#ffa500", }, 
]

// 答辩评审状态 
export const reply = {
    // 1: 待审核 2: 审核通过 3:审核不通过(驳回) 4:重新提交 
    0: { txt: "待提交", col: "#1963f7", }, 
    1: { txt: "审核中", col: "", }, 
    2: { txt: "通过", col: "", }, 
    3: { txt: "不通过", col: "#ffa500", }, 
    4: { txt: "待提交", col: "#1963f7", }, 
}
